/* Core & libraries */
import React, {useState, useEffect, useRef} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons/index.js";
import {ErrorMessage, Field, Formik, getIn} from "formik";

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from "../../../contexts/localeContext";
import {createValidationPolicyYupSchema, useValidationService} from "../../../resources/validations/validations";

/* Components */


/* Styles */
import styles from "./styles.js";

const messages = defineMessages({
  discountCodePlaceholder: {
    id: 'overrideDiscountTierModal.discountCodePlaceholder',
  },
});


const Content = ({setShowModal, discountData, staticContent, handleSaveModal }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const intl = useIntl();
  const globalLocale = useLocaleContext();
  const formRef = useRef(null);

  const { overrideDiscountTierApiValidationObj } = useValidationService()
  const [overrideDiscountSchema, setOverrideDiscountSchema] = useState({});
  const [requiredTier1, setRequiredTier1] = useState(false)
  const [requiredTier2, setRequiredTier2] = useState(false)
  const [requiredTier3, setRequiredTier3] = useState(false)

  const tierCode1 = discountData?.tierLevels?.[0]?.tierCode ? discountData?.tierLevels?.[0]?.tierCode : staticContent?.discountsData?.discounts?.[0]?.title;
  const tierCode2 = discountData?.tierLevels?.[1]?.tierCode ? discountData?.tierLevels?.[1]?.tierCode : staticContent?.discountsData?.discounts?.[1]?.title;
  const tierCode3 = discountData?.tierLevels?.[2]?.tierCode ? discountData?.tierLevels?.[2]?.tierCode : staticContent?.discountsData?.discounts?.[2]?.title;


  useEffect(() => {
    // //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(overrideDiscountTierApiValidationObj);
    setOverrideDiscountSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm =  (values, setSubmitting) => {
    let payload = {};

    switch (values.selectedOption) {
      case "1":
        payload = {
        tierCode: tierCode1,
        discountCode: values.discountCode,
        currentTierCode: values.currentTierCode
        }
        break;
      case "2":
        payload ={
          tierCode: tierCode2,
          discountCode: values.discountCode2,
          currentTierCode: values.currentTierCode
        }
        break;
      case "3":
        payload ={
          tierCode: tierCode3,
          discountCode: values.discountCode3,
          currentTierCode: values.currentTierCode
        }
        break;
      default:
        payload={
          tierCode: "",
          discountCode: "",
          currentTierCode: values.currentTierCode
        };
    }
    if (payload.tierCode === discountData?.tierLevels?.[0]?.tierCode && payload.discountCode === ""){
      setRequiredTier1(true)
    } else if (payload.tierCode === discountData?.tierLevels?.[1]?.tierCode && payload.discountCode === "") {
      setRequiredTier2(true)
    } else if  (payload.tierCode === discountData?.tierLevels?.[2]?.tierCode && payload.discountCode === "") {
      setRequiredTier3(true)
    } else {
      handleSaveModal(payload)
      setSubmitting(false);
    }
  }


  const handleTierChange = (changedField, fieldsToClear) => (e, handleChange, setFieldValue) => {
    setRequiredTier1(false);
    setRequiredTier2(false);
    setRequiredTier3(false);

    const value = e.target.value;
    handleChange(e);

    setFieldValue(changedField, value);

    fieldsToClear.forEach((field) => setFieldValue(field, ""));
  };

  const discountTier1Change = handleTierChange("discountCode", ["discountCode2", "discountCode3"]);
  const discountTier2Change = handleTierChange("discountCode2", ["discountCode", "discountCode3"]);
  const discountTier3Change = handleTierChange("discountCode3", ["discountCode", "discountCode2"]);


  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          discountCode: discountData?.activeTier?.tierId.toString() === "1" ? discountData?.activeTier?.discountCode : "",
          discountCode2: discountData?.activeTier?.tierId.toString() === "2" ? discountData?.activeTier?.discountCode : "",
          discountCode3: discountData?.activeTier?.tierId.toString() === "3" ? discountData?.activeTier?.discountCode : "",
          currentTierCode: discountData?.activeTier?.tierCode ? discountData?.activeTier?.tierCode :"",
          selectedOption: discountData?.activeTier?.tierId ? discountData?.activeTier?.tierId.toString() : "0"
        }}
        validationSchema={overrideDiscountSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            dirty,
            isSubmitting,
            setFieldValue,
            enableReinitialize
          }) => (
          <form onSubmit={handleSubmit} >
            <div className={classes.listContainer}>
              <div
                className={values.selectedOption === "0" ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer}
                onClick={() => {
                  setFieldValue("selectedOption", "0");
                  setFieldValue("discountCode2", "");
                  setFieldValue("discountCode", "");
                }}
              >
                <Field
                  type="radio"
                  name="selectedOption"
                  value="0"
                  onChange={() => {
                    setFieldValue("selectedOption", "0");
                    setFieldValue("discountCode2", "");
                    setFieldValue("discountCode", "");
                  }}
                />
                <div>
                  <p><FormattedMessage id="admin.companyDetails.noDiscountTitle" values={{ tierName: staticContent?.discountsData?.noTierTitle}} /></p>
                </div>
              </div>
              <div
                className={values.selectedOption === "1" ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer}
                onClick={() => {
                  setFieldValue("selectedOption", "1");
                }}
              >
                <Field
                  type="radio"
                  name="selectedOption"
                  value="1"
                  onChange={(e) => {
                    setFieldValue("selectedOption", "1");
                    discountTier1Change(e, handleChange, setFieldValue)
                  }}
                />

                <div>
                  <p><FormattedMessage id="admin.companyDetails.discountTitleTier" values={{ tierName: staticContent?.discountsData?.discounts?.[0]?.title}} /></p>
                </div>
              </div>
              {values.selectedOption === "1" &&
                <div className={classes.inputContainer}>
                <Field
                    placeholder={intl.formatMessage(messages.discountCodePlaceholder)}
                    type='text'
                    name='discountCode'
                    id='discountCode'
                    onChange={(e) =>
                      discountTier1Change(e, handleChange, setFieldValue)
                    }
                    disabled={discountData?.activeTier?.tierId.toString() === values?.selectedOption }
                    className={
                      (errors.discountCode && touched.discountCode) || requiredTier1
                        ? 'input-error'
                        : null
                    }
                  />
                  <ErrorMessage
                    name='discountCode'
                    component='span'
                    className={classes.error}
                  />
                  { requiredTier1 && (
                    <div className={classes.requiredError}>
                      <FormattedMessage id="overrideDiscountTierModal.validation.discountCodeRequired" />
                    </div>
                  )}
                </div>
              }

              {
                discountData?.tierLevels?.[1]?.tierId.toString() === "2" &&
                <>
                  <div
                    className={values.selectedOption === "2" ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer}
                    onClick={() => {
                      setFieldValue("selectedOption", "2");

                    }}
                  >
                    <Field
                      type="radio"
                      name="selectedOption"
                      value="2"
                      onChange={() => {
                        setFieldValue("selectedOption", "2");
                      }}
                    />
                    <div>
                      <p><FormattedMessage id="admin.companyDetails.discountTitleTier" values={{ tierName: staticContent?.discountsData?.discounts?.[1]?.title}} /></p>
                    </div>
                  </div>
                  {values.selectedOption === "2" &&
                    <div className={classes.inputContainer}>
                      <Field
                        placeholder={intl.formatMessage(messages.discountCodePlaceholder)}
                        type='text'
                        name='discountCode2'
                        id='discountCode2'
                        onChange={(e) =>
                          discountTier2Change(e, handleChange, setFieldValue)
                        }
                        disabled={discountData?.activeTier?.tierId.toString() === values?.selectedOption }
                        className={
                          (errors.discountCode2 && touched.discountCode2) || requiredTier2
                            ? 'input-error'
                            : null
                        }
                      />
                      <ErrorMessage
                        name='discountCode2'
                        component='span'
                        className={classes.error}
                      />
                      { requiredTier2 && (
                        <div className={classes.requiredError}>
                          <FormattedMessage id="overrideDiscountTierModal.validation.discountCodeRequired" />
                        </div>
                      )}
                    </div>
                  }
                </>
              }
              {
                discountData?.tierLevels?.[2]?.tierId.toString() === "3" &&
                <>
                  <div
                    className={values.selectedOption === "3" ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer}
                    onClick={() => {
                      setFieldValue("selectedOption", "3");

                    }}
                  >
                    <Field
                      type="radio"
                      name="selectedOption"
                      value="3"
                      onChange={() => {
                        setFieldValue("selectedOption", "3");
                      }}
                    />
                    <div>
                      <p><FormattedMessage id="admin.companyDetails.discountTitleTier" values={{ tierName: staticContent?.discountsData?.discounts?.[2]?.title}}/> </p>
                    </div>
                  </div>
                  {values.selectedOption === "3" &&
                    <div className={classes.inputContainer}>
                      <Field
                        placeholder={intl.formatMessage(messages.discountCodePlaceholder)}
                        type='text'
                        name='discountCode3'
                        id='discountCode3'
                        onChange={(e) =>
                          discountTier3Change(e, handleChange, setFieldValue)
                        }
                        disabled={discountData?.activeTier?.tierId.toString() === values?.selectedOption }
                        className={
                          (errors.discountCode2 && touched.discountCode2) || requiredTier3
                            ? 'input-error'
                            : null
                        }
                      />
                      <ErrorMessage
                        name='discountCode3'
                        component='span'
                        className={classes.error}
                      />
                      { requiredTier3 && (
                        <div className={classes.requiredError}>
                          <FormattedMessage id="overrideDiscountTierModal.validation.discountCodeRequired" />
                        </div>
                      )}
                    </div>
                  }
                </>
              }
            </div>
            <div className={classes.btnContainer}>
              <ContainerFluid>
                <Row className={classes.btnsRow}>
                  <Col className={classes.colCancel}>
                    <UCButton
                      onClick={() => setShowModal(false)}
                      type="default"
                      className={classes.cancelBtn}
                      text={<FormattedMessage id="overrideDiscountTierModal.cancel"/>}
                    />
                  </Col>
                  <Col className={classes.colChoose}>
                    <UCButton
                      className={classes.chooseBtn}
                      disabled={!dirty || discountData?.activeTier?.tierId.toString() === values?.selectedOption }
                      onClick={handleFormSubmit}
                      type="primary"
                      text={<FormattedMessage id="overrideDiscountTierModal.confirm"/>}
                      spinner={{
                        name:"overrideDiscountSpinner",
                        size: 20
                      }}
                    />
                  </Col>
                </Row>
              </ContainerFluid>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default Content;